import { useState, useEffect } from "react";
import { Dialog } from "@mui/material";
import { useRecordEvent } from "app/hook";
import { AnalyticsEventType } from "app/types";
import I18n from "common/i18n";
import { btnDelay, useScale, usePlaySound } from "common/utils";
import { ParentCloseBtn, FadeTransition } from "common/elements";
import { Shape } from "./shape";

export const ParentGate = ({
  visible,
  confirm,
  close,
  canClose = true,
}: {
  visible: boolean;
  confirm?: () => void;
  close: () => void;
  canClose?: boolean;
}) => {
  const play = usePlaySound();
  const { scale } = useScale();
  const [show, setShow] = useState(true);
  const handleRecordEvent = useRecordEvent();
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    setShow(true);
    setSuccess(false);
  }, [visible]);

  // 長押し成功時に自動遷移
  useEffect(() => {
    if (!success) return;
    const timer = setTimeout(() => {
      btnDelay(() => {
        play();
        setShow(false);
        setSuccess(false);
        handleRecordEvent(AnalyticsEventType.PARENT_GATE_SUCCESS_BTN_CLICK);
        if (confirm) {
          confirm();
        }
      });
    }, 500);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  const handleClose = () => {
    btnDelay(() => {
      play();
      close();
    });
  };

  return (
    <Dialog
      fullScreen
      maxWidth={false}
      open={visible && show}
      sx={{ zIndex: 9999999999 }}
      TransitionComponent={FadeTransition}
      PaperProps={{ style: { backgroundColor: "transparent" } }}
      transitionDuration={{ enter: 1000, exit: 500 }}
      onClose={canClose ? handleClose : undefined}
    >
      <div className="flex-col-center w-full h-full bg-textcolor-black/50">
        <div style={{ transform: `scale(${scale})` }}>
          <div className="flex-col-el w-[480px] border-solid border-gray2-30 border-[16px] rounded-[16px] bg-gray2-30">
            <div className="flex-col-el justify-start w-full h-full relative p-6 rounded-[8px] bg-white">
              {canClose && <ParentCloseBtn close={handleClose} />}

              {/* ヘッダー */}
              <div className="flex-row-el items-center gap-2 mb-4 pb-3 border-b border-outline shrink-0">
                <span className="material-symbols-outlined !text-[54px] text-red-100">lock</span>
                <h2 className="text-[33px] text-textcolor-black">
                  {I18n.t("MSG_PARENT_GATE_TITLE")}
                </h2>
              </div>

              {/* パズルエリア */}
              <Shape setSuccess={setSuccess} />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
